import { useEffect, useState } from "react";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import { useNavigate } from "react-router-dom";
import {
  Avatar,
  Box,
  Card,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Stack,
} from "@mui/material";
import { useLoading } from "../../../../context/loadingcontext";
import axios from "axios";
import { BASE_URL, postData } from "../../../Utils/Baseurl";
import MaterialTypography from "../../../../components/MaterialTypography";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";

const ProjectReportTabel = () => {
  const navigate = useNavigate();
  const { setCirleLoading } = useLoading();
  const [project, setProject] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedProjectId, setSelectedProjectId] = useState(null);
  const open = Boolean(anchorEl);

  useEffect(() => {
    fetchProjectData();
  }, []);

  /**
   * Fetches a summary of all projects from the API and updates the state with the retrieved data.
   * Retrieves the authentication token from session storage and includes it in the request headers.
   * Upon successful response, sets the project state with the fetched data.
   * Logs any errors encountered during the fetch operation.
   */
  const fetchProjectData = async () => {
    setCirleLoading(true);
    try {
      const token = sessionStorage.getItem("token");
      const response = await axios.get(`${BASE_URL}api/all-projects-summary/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = response.data.data;
      setProject(data);
    } catch (error) {
      console.log(error, "error");
    } finally {
      setCirleLoading(false);
    }
  };

  /**
   * Deletes a project from the API based on the selectedProjectId.
   * Retrieves the authentication token from session storage and includes it in the request headers.
   * Upon successful response, logs the response data.
   * Logs any errors encountered during the delete operation.
   */

  const handleClick = (event, projectId) => {
    setAnchorEl(event.currentTarget);
    setSelectedProjectId(projectId);
  };

  const handleClose = async (item) => {
    if (item && selectedProjectId) {
      const formdata = new FormData();
      formdata.append("project_id", item);
      try {
        const data = await postData("api/updateActualEndDates/", formdata);
        console.log(data, "data");
      } catch (error) {
        console.log(error);
      }
      navigate(`/project-report/view-report`, { state: item });
    }

    setAnchorEl(null);
    setSelectedProjectId(null);
  };

  const truncate = (desc) =>
    desc?.length > 25 ? `${desc.substring(0, 140)}...` : desc;

  return (
    <DashboardLayout>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        spacing={2}
        p={1}
        mb={2}
      >
        <Stack direction="column" spacing={0}>
          <MaterialTypography variant="h5" fontWeight="medium" color="dark">
            Project
          </MaterialTypography>
          <MaterialTypography variant="caption" color="text">
            You can view the projects here.
          </MaterialTypography>
        </Stack>
      </Stack>

      <Grid container spacing={2} sx={{ mt: 2, p: 1 }}>
        {project.map((item, index) => {
          return (
            <Grid size={{ xs: 12, sm: 3, md: 3 }} key={item.project_id}>
              <Card sx={{ p: 1, zIndex: 0 }}>
                <Box sx={{ position: "absolute", top: 3, right: 3 }}>
                  <IconButton
                    onClick={(event) => handleClick(event, item.project_id)}
                    size="small"
                  >
                    <MoreVertIcon />
                  </IconButton>
                  <Menu
                    anchorEl={anchorEl}
                    open={open && selectedProjectId === item.project_id}
                    onClose={() => handleClose("")}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "right",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                  >
                    <MenuItem onClick={() => handleClose(item.project_id)}>
                      View Report
                    </MenuItem>
                  </Menu>
                </Box>
                <Grid container spacing={2}>
                  <Grid size={{ xs: 12, md: 12 }}>
                    <Stack direction="row" spacing={1} alignItems="center">
                      <Avatar
                        alt="Remy Sharp"
                        src={BASE_URL + item.project_logo}
                        sx={{
                          width: 40,
                          height: 40,
                          "& img": {
                            objectFit: "cover",
                            width: "100%",
                            height: "100%",
                          },
                        }}
                      />
                      <Stack direction="column" spacing={0}>
                        <p
                          style={{
                            fontSize: "12px",
                            fontWeight: "bold",
                            cursor: "pointer",
                            color: "text.primary",
                          }}
                          onClick={() => handleClose("View")}
                        >
                          {item.project_name}
                        </p>

                        <MaterialTypography
                          variant="caption"
                          color="text"
                          sx={{ fontSize: "10px" }}
                        >
                          {item.project_code}
                        </MaterialTypography>
                      </Stack>
                    </Stack>
                  </Grid>
                </Grid>
                <Grid container spacing={2} mt={1}>
                  <Grid size={{ xs: 12, md: 12 }}>
                    <MaterialTypography
                      variant="body2"
                      color="text"
                      sx={{ fontSize: "10px" }}
                    >
                      {truncate(item.description)}
                    </MaterialTypography>
                  </Grid>
                </Grid>
                <Grid container spacing={2} mt={1}>
                  <Grid size={{ xs: 12, md: 12 }}>
                    <Stack direction="row" spacing={1}>
                      <Avatar
                        alt="Remy Sharp"
                        src={item.manager_profile}
                        sx={{
                          width: 30,
                          height: 30,
                          "& img": {
                            objectFit: "cover",
                            width: "100%",
                            height: "100%",
                          },
                        }}
                      />
                      <Stack direction="column" spacing={0}>
                        <MaterialTypography
                          variant="h6"
                          fontWeight="bold"
                          color="text"
                          sx={{ fontSize: "10px" }}
                        >
                          {item.manager}
                        </MaterialTypography>
                        <MaterialTypography
                          variant="h6"
                          fontWeight="bold"
                          color="text"
                          sx={{ fontSize: "10px" }}
                        >
                          Project Manager
                        </MaterialTypography>
                      </Stack>
                    </Stack>
                  </Grid>
                </Grid>
                <Grid container spacing={2} mt={1}>
                  <Grid size={{ xs: 6, lg: 6 }}>
                    <Stack direction="column" spacing={0}>
                      <MaterialTypography
                        variant="h6"
                        fontWeight="bold"
                        color="text"
                        sx={{ fontSize: "10px" }}
                      >
                        Start Date
                      </MaterialTypography>
                      <MaterialTypography
                        variant="h6"
                        fontWeight="bold"
                        color="text"
                        sx={{ fontSize: "10px" }}
                      >
                        {item.start_date}
                      </MaterialTypography>
                    </Stack>
                  </Grid>
                  <Grid
                    size={{ xs: 6, lg: 6 }}
                    sx={{ display: "flex", flexDirection: "row-reverse" }}
                  >
                    <Stack direction="column" spacing={0}>
                      <MaterialTypography
                        variant="h6"
                        fontWeight="bold"
                        color="text"
                        sx={{ fontSize: "10px" }}
                      >
                        Live Date
                      </MaterialTypography>
                      <MaterialTypography
                        variant="h6"
                        fontWeight="bold"
                        color="text"
                        sx={{
                          fontSize: "10px",
                          color: "green",
                          animation: "blinker 2s linear infinite",
                          "@keyframes blinker": {
                            "50%": {
                              opacity: 0,
                            },
                          },
                        }}
                      >
                        {item.end_date}
                      </MaterialTypography>
                    </Stack>
                  </Grid>
                </Grid>
                <Grid container spacing={2} mt={1}>
                  <Grid size={{ xs: 6, lg: 6 }}>
                    <Stack direction="row" spacing={0} alignItems="center">
                      <CalendarMonthIcon
                        sx={{ color: "#00C853", fontSize: 16 }}
                      />
                      <MaterialTypography
                        variant="body2"
                        color="text"
                        sx={{ fontSize: "10px" }}
                      >
                        {item.days_left} days left
                      </MaterialTypography>
                    </Stack>
                  </Grid>
                  <Grid
                    size={{ xs: 6 }}
                    sx={{ display: "flex", flexDirection: "row-reverse" }}
                  >
                    <Stack direction="column" spacing={0}>
                      <MaterialTypography
                        variant="body2"
                        color="text"
                        sx={{ fontSize: "10px" }}
                      >
                        Completed tasks: {item.completion_percent}%
                      </MaterialTypography>
                    </Stack>
                  </Grid>
                </Grid>
                {item?.status && (
                  <Box
                    sx={{
                      width: "100px",
                      height: "100px",
                      overflow: "hidden",
                      position: "absolute",
                      top: 0,
                      right: 0,
                      zIndex: -1,
                    }}
                  >
                    <Box
                      component="span"
                      sx={{
                        fontSize: "10px",
                        fontWeight: "bold",
                        color: "#fff",
                        textAlign: "center",
                        position: "absolute",
                        width: "140px",
                        top: "25px",
                        right: "-40px",
                        backgroundColor: item?.color || "orange",
                        padding: "2px 0",
                        transform: "rotate(45deg)",
                        boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                      }}
                    >
                      {item?.status}
                    </Box>
                  </Box>
                )}
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </DashboardLayout>
  );
};

export default ProjectReportTabel;
